/**
 * @description: 会员消费明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="mr-hxm-report">
        <div class="member-xm-list">
            <p class="p-hint">注：房费账户、赠送账户及通用账户消费金额均已扣除退款金额</p>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="xmTime">
                        <input type="text" class="form-control laydate-icon" v-model="xmStartTime" /> -
                        <input type="text" class="form-control laydate-icon" v-model="xmEndTime" />
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="xmShop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-3">包厢号:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="xm_box" data-placeholder="请选择消费包厢" disabled>
                    </select>
                </div>
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="xmQuery_conditions">
                        <option value="vip_card">会员卡号</option>
                        <option value="username">会员姓名</option>
                        <option value="mobile">会员手机号</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="xmSearch_info" :placeholder="xmEmployeeinput">
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-3">操作人:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="xm_admin" data-placeholder="请选择操作人" disabled></select>
                </div>
                <label class="list-label-4">费用类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="xm_pay_type" data-placeholder="请选择费用类型">
                        <option value="0">全部</option>
                        <option value="1">商品</option>
                        <option value="2">时间费</option>
                    </select>
                </div>
                <div class="">
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitXmTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getXmExportSet">导出</button>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-8">房费账户消费金额:</label>
                <div class="list-total" ref="xm_ff_amount"></div>
                <label class="list-label-8">赠送账户消费金额:</label>
                <div class="list-total" ref="xm_zs_amount"></div>
                <label class="list-label-8">通用账户消费金额:</label>
                <div class="list-total" ref="xm_ty_amount"></div>
            </div>
            <div class="row row-margin">
                <label class="list-label-8">房费账户退款金额:</label>
                <div class="list-total" ref="xm_ff_refund"></div>
                <label class="list-label-8">赠送账户退款金额:</label>
                <div class="list-total" ref="xm_zs_refund"></div>
                <label class="list-label-8">通用账户退款金额:</label>
                <div class="list-total" ref="xm_ty_refund"></div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="xmList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="xmExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='xmExport_allcheck' @click='xmExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="create_time">
                            <label>消费时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="shop_name">
                            <label>消费门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="room_name">
                            <label>包厢号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="bill_no">
                            <label>账单号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="vip_level">
                            <label>会员卡等级</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="vip_card">
                            <label>会员卡号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="username">
                            <label>会员姓名</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="mobile">
                            <label>会员手机号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="vip_room_account">
                            <label>房费账户消费金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="vip_present_account">
                            <label>赠送账户消费金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="vip_account">
                            <label>通用账户消费金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="vip_room_account_refund">
                            <label>房费账户退款金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="present_refund_amount">
                            <label>赠送账户退款金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="vip_account_refund">
                            <label>通用账户退款金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="admin_name">
                            <label>操作人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="pay_type_name">
                            <label>费用类型</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='xmExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='xmExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 预约导出弹窗 -->
            <div class="book-export-pop ele-hide" ref="book_export_pop">
                <div class="red-tip">由于当前导出数据量较大，您需操作预约导出，操作预约导出后，需等待系统生成数据，数据生成完成后可在历史预约中下载查看！数据生成过程中可以关闭当前窗口，可再次操作“导出”进入查看导出进度。</div>
                <div class="pop-row center">
                    <el-button type="primary" @click="doBookExport">预约导出</el-button>
                    <el-button @click="cancelExport">取消</el-button>
                </div>
                <div class="row-tip">历史预约（注：历史预约仅显示该登录账号最近一次预约操作数据）</div>
                <div class="pop-row bottom" v-if="book_export_log_list.length>0">
                    <div class="time">{{book_export_log_list[0].create_time}}</div>
                    <div class="right">
                        <span class="status">{{book_export_log_list[0].status_name}}</span>
                        <el-button type="primary" :disabled="book_export_log_list[0].status==0" @click="downloadFile">下载</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                xmStartTime: "",
                xmEndTime: "",
                xmEmployeeinput: '请输入会员卡号',
                xmSearch_field: "vip_card",
                xmSearch_info: "",
                admin_id: '',
                pay_type: '0', // 费用类型，0，全部，1：商品，2：时间费
                xmExport_allcheck: false,
                c_xmExport_allcheck: false,
                xmExport_checkModel: [],
                xmExport_checkData: ['create_time', 'shop_name', 'room_name', 'bill_no', 'vip_level', 'vip_card', 'username', 'mobile', 'vip_room_account', 'vip_present_account', 'vip_account', 'vip_room_account_refund', 'present_refund_amount', 'vip_account_refund', 'admin_name', 'pay_type_name'],
                xmExport_type: 1,
                list_page: 1,
                book_export_log_list: [],
            }
        },
        watch: {
            xmExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.xmExport_checkModel.length >= this.xmExport_checkData.length) {
                        this.xmExport_allcheck = true;
                        this.c_xmExport_allcheck = true;
                    } else {
                        this.xmExport_allcheck = false;
                        this.c_xmExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.xmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.xmEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.innitDate(); // 日期
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            // 下拉选项
            $(_this.$refs.xmQuery_conditions).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1
            }).change(function() {
                _this.xmSearch_field = $(this).val();
                if(_this.xmSearch_field == 'vip_card') {
                    _this.xmEmployeeinput = '请输入会员卡号';
                } else if(_this.xmSearch_field == 'username') {
                    _this.xmEmployeeinput = '请输入会员姓名';
                } else if(_this.xmSearch_field == 'mobile') {
                    _this.xmEmployeeinput = '请输入会员手机号';
                }
            });

            $(_this.$refs.xm_pay_type).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1
            }).change(function() {
                _this.pay_type = $(this).val();
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.xmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.xmEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.xmStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.xmEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.xmTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                }, function(start, end, label) {
                    _this.xmStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.xmEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.xmShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    $(_this.$refs.xm_box).html("");
                                    $(_this.$refs.xm_box).prop("disabled", true);
                                    $(_this.$refs.xm_admin).html("");
                                    $(_this.$refs.xm_admin).prop("disabled", true);
                                    return;
                                }
                                $(_this.$refs.xm_box).prop("disabled", false);
                                $(_this.$refs.xm_admin).prop("disabled", false);
                                _this.getShopBox(e.params.data.id);
                                _this.getAdmin(e.params.data.id)
                                _this.setShopDefaultTime(e.params.data.id)
                            });
                            $(_this.$refs.xmShop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id)
                            // 消费包厢
                            $(_this.$refs.xm_box).prop("disabled", false);
                            _this.getShopBox(data.response.result[1].id);
                            // 操作人
                            $(_this.$refs.xm_admin).prop("disabled", false);
                            _this.getAdmin(data.response.result[1].id);
                            _this.innitXmTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢数据
            getShopBox: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoom",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.xm_box).html("");
                            $(_this.$refs.xm_box).select2({
                                data: arr,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },
            // 获取操作人数据
            getAdmin: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "User/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result']['user_info'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.xm_admin).html("");
                            $(_this.$refs.xm_admin).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            // 初始化会员消费明细报表
            innitXmTable: function() {
                let _this = this;
                $(_this.$refs.xmList).bootstrapTable('destroy');
                $(_this.$refs.xmList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getXmList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: 'middle',
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "create_time",
                        title: "消费时间",
                        width: "100",
                        valign: 'middle'
                    }, {
                        field: "shop_name",
                        title: "消费门店",
                        width: "130",
                        valign: 'middle',
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "room_name",
                        title: "包厢号",
                        width: "7%",
                        valign: 'middle'
                    }, {
                        field: "bill_no",
                        title: "账单号",
                        width: "7%",
                        valign: 'middle'
                    }, {
                        field: "vip_level",
                        title: "会员卡等级",
                        width: "7%",
                        valign: 'middle'
                    }, {
                        field: "vip_card",
                        title: "会员卡号",
                        width: "110",
                        valign: 'middle'
                    }, {
                        field: "username",
                        title: "会员姓名",
                        width: "7%",
                        valign: 'middle'
                    }, {
                        field: "mobile",
                        title: "会员手机号",
                        width: "7%",
                        valign: 'middle'
                    }, {
                        field: "vip_room_account",
                        title: "房费账户<br />消费金额",
                        width: "7%",
                        valign: 'middle'
                    }, {
                        field: "vip_present_account",
                        title: "赠送账户<br />消费金额",
                        width: "7%",
                        valign: 'middle'
                    }, {
                        field: "vip_account",
                        title: "通用账户<br />消费金额",
                        width: "7%",
                        valign: 'middle'
                    }, {
                        field: "vip_room_account_refund",
                        title: "房费账户<br />退款金额",
                        width: "7%",
                        valign: 'middle'
                    }, {
                        field: "present_refund_amount",
                        title: "赠送账户<br />退款金额",
                        width: "7%",
                        valign: 'middle'
                    }, {
                        field: "vip_account_refund",
                        title: "通用账户<br />退款金额",
                        width: "7%",
                        valign: 'middle'
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: "7%",
                        valign: 'middle'
                    }, {
                        field: "pay_type_name",
                        title: "费用类型",
                        width: "7%",
                        valign: 'middle'
                    }, ]
                });
            },
            // 获取会员消费明细报表列表
            getXmList: function(params) {
                let _this = this,
                    shop_id = $(_this.$refs.xmShop).val(),
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                _this.list_page = pageNumber;
                let vip_card = '',
                    username = '',
                    mobile = '';
                if(_this.xmSearch_field == 'vip_card') {
                    vip_card = _this.xmSearch_info;
                } else if(_this.xmSearch_field == 'username') {
                    username = _this.xmSearch_info;
                } else if(_this.xmSearch_field == 'mobile') {
                    mobile = _this.xmSearch_info;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.xmStartTime,
                            "end_time": _this.xmEndTime,
                            "shop_id": shop_id,
                            "room_id": $.trim($(_this.$refs.xm_box).val()),
                            "admin_id": $.trim($(_this.$refs.xm_admin).val()),
                            "vip_card": vip_card,
                            "username": username,
                            "mobile": mobile,
                            "pay_type": _this.pay_type
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getVipConsumeDetailList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $(_this.$refs.xm_ff_amount).text(data.response.result.vip_room_account_total);
                            $(_this.$refs.xm_zs_amount).text(data.response.result.vip_present_account_total);
                            $(_this.$refs.xm_ty_amount).text(data.response.result.vip_account_total);
                            $(_this.$refs.xm_ff_refund).text(data.response.result.vip_room_account_refund_total);
                            $(_this.$refs.xm_zs_refund).text(data.response.result.present_refund_amount_total);
                            $(_this.$refs.xm_ty_refund).text(data.response.result.vip_account_refund_total);
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getXmExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/vipConsumeDetailExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.xmExport_checkModel = data.response.result.export_fields;
                                _this.xmExport_type = data.response.result.export_type;
                            } else {
                                _this.xmExport_checkModel = _this.xmExport_checkData;
                                _this.xmExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.xmExport_alert)
                }, function() {
                    _this.checkExport();
                });
            },
            // 导出字段全选
            xmExportCheckedAll: function() {
                let _this = this;
                _this.xmExport_allcheck = _this.c_xmExport_allcheck;
                if(!_this.xmExport_allcheck) { // 实现全选
                    _this.xmExport_checkModel = [];
                    _this.xmExport_checkData.forEach(function(item) {
                        _this.xmExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.xmExport_checkModel = [];
                }
            },

            // 检查导出状态
            checkExport() {
                let _this = this,
                    shop_id = $(_this.$refs.xmShop).val();
                let vip_card = '',
                    username = '',
                    mobile = '';
                if (_this.xmSearch_field == 'vip_card') {
                    vip_card = _this.xmSearch_info;
                } else if (_this.xmSearch_field == 'username') {
                    username = _this.xmSearch_info;
                } else if (_this.xmSearch_field == 'mobile') {
                    mobile = _this.xmSearch_info;
                }
                Vue.axios.post('exportBook/exportCheck', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'vipConsumeDetail',
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.xmStartTime,
                            "end_time": _this.xmEndTime,
                            "shop_id": shop_id,
                            "room_id": $.trim($(_this.$refs.xm_box).val()),
                            "admin_id": $.trim($(_this.$refs.xm_admin).val()),
                            "vip_card": vip_card,
                            "username": username,
                            "mobile": mobile,
                            "pay_type": _this.pay_type
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.closeAll()
                        if (res.data.response.result.status == '1') { // 原逻辑直接导出
                            _this.exportXmList();
                        }else {
                            _this.book_export_log_list = res.data.response.result.log_list
                            // 预约导出弹窗
                            layer.confirm('', {
                                skin: 'public-alert-skin',
                                type: 1,
                                btn: [], // 按钮
                                title: ['导出提示', true],
                                area: ['700px', ''], // 宽高
                                content: $(_this.$refs.book_export_pop),
                                offset: '100px',
                            });
                        }

                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 预约导出
            doBookExport() {
                let _this = this;

                let export_fields = JSON.stringify(_this.xmExport_checkModel);
                let vip_card = '',
                    username = '',
                    mobile = '';
                if(_this.xmSearch_field == 'vip_card') {
                    vip_card = _this.xmSearch_info;
                } else if(_this.xmSearch_field == 'username') {
                    username = _this.xmSearch_info;
                } else if(_this.xmSearch_field == 'mobile') {
                    mobile = _this.xmSearch_info;
                }

                Vue.axios.post('exportBook/addExportBook', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'vipConsumeDetail',
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.xmStartTime,
                            "end_time": _this.xmEndTime,
                            "shop_id": $(_this.$refs.xmShop).val(),
                            "room_id": $.trim($(_this.$refs.xm_box).val()),
                            "admin_id": $.trim($(_this.$refs.xm_admin).val()),
                            "vip_card": vip_card,
                            "username": username,
                            "mobile": mobile,
                            "pay_type": _this.pay_type,
                            "export_fields": export_fields,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.book_export_log_list = res.data.response.result.log_list
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 下载文件
            downloadFile() {
                // 已知文件的URL
                const fileUrl = this.book_export_log_list[0].file_url
                const fileName = "file.pdf"; // 自定义文件名

                // 创建一个隐藏的 <a> 元素
                const a = document.createElement("a");
                a.href = fileUrl;
                a.download = fileName;

                // 将 <a> 元素添加到页面中
                document.body.appendChild(a);

                // 触发点击事件，下载文件
                a.click();

                // 下载完成后移除该 <a> 元素
                document.body.removeChild(a);
            },

            cancelExport() {
                layer.closeAll()
            },

            // 确定“导出”
            exportXmList: function() {
                let _this = this;

                let export_fields = JSON.stringify(_this.xmExport_checkModel);
                let vip_card = '',
                    username = '',
                    mobile = '';
                if(_this.xmSearch_field == 'vip_card') {
                    vip_card = _this.xmSearch_info;
                } else if(_this.xmSearch_field == 'username') {
                    username = _this.xmSearch_info;
                } else if(_this.xmSearch_field == 'mobile') {
                    mobile = _this.xmSearch_info;
                }
                window.location.href = Vue.ctUrl + "FinanceReport/vipConsumeDetailExport?" +
                    "&start_time=" + _this.xmStartTime +
                    "&end_time=" + _this.xmEndTime +
                    "&shop_id=" + $(_this.$refs.xmShop).val() +
                    "&room_id=" + $.trim($(_this.$refs.xm_box).val()) +
                    "&admin_id=" + $.trim($(_this.$refs.xm_admin).val()) +
                    "&vip_card=" + vip_card +
                    "&username=" + username +
                    "&mobile=" + mobile +
                    "&pay_type=" + _this.pay_type +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.xmExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .member-xm-list {
        .fixed-table-body {
            overflow-x: scroll;
            table {
                // width: 1300px;
                // table-layout: fixed;
                word-break: break-all;
            }
        }
        .fixed-table-body::-webkit-scrollbar {
            position: absolute;
            top: 0;
            left: 0;
            height: 30px;
        }
    }

    // 预约导出
    .book-export-pop {
        position: relative;
        .red-tip {
            color: red;
        }
        .pop-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            &.center {
                margin: 30px 0 60px 0;
                justify-content: center;
            }
            &.bottom {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                padding: 0 35px;
                box-sizing: border-box;
                justify-content: space-between;
                .right {
                    .status {
                        margin-right: 10px;
                        color: #409EFF;
                    }
                }
            }
        }
        .row-tip {
            margin-bottom: 20px;
        }
        .el-button {
            width: 100px;
        }
    }
</style>